import React from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const WhatsNewSpotlightButton = () => {
	const { formatMessage } = useIntl();
	return (
		<DropdownItem
			// onClick={}
			data-testid="issue-view-common-views.child-issues-panel.heading.whats-new-spotlight-button"
		>
			{formatMessage(messages.spotlightButtonLabel)}
		</DropdownItem>
	);
};

export default WhatsNewSpotlightButton;
